// FileUploadForm.tsx
import React, { useState } from 'react';
import { instance } from '../../api/axiosInstance'; // 위에서 만든 axios 인스턴스 import
import ManagerSidebar from '../../components/ManagerSidebar';
import NoticeComponent from '../../components/NoticeComponent';
import { FaUpload } from "react-icons/fa6";

const FileUploadForm: React.FC = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      await instance.post('/api/files/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('File uploaded successfully!');
    } catch (error) {
      alert('File upload failed.');
    }
  };

  return (
    <section className="max-w-[2560px] w-full mx-auto mt-[90px] h-screen flex">
        <ManagerSidebar />

        <article className="max-w-[1440px] w-full mx-auto flex-1 py-8">
          <NoticeComponent title="업로드 파일" content="" />
          <div className="flex flex-col flex-1 overflow-auto overflow-x-hidden w-full mt-[25px]">
            <div className='max-w-[600px] bg-white'>
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <input
                    type="file"
                    onChange={handleFileChange}
                    className="w-full text-sm text-gray-500 !cursor-pointer file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-MainTextColor file:text-white hover:file:bg-MainColor !transition !duration-300 !ease-in-out"
                    />
                </div>
                <button
                  type="submit"
                  className="w-full mt-8 bg-black text-white font-bold text-sm py-4 rounded-lg hover:bg-opacity-70 transition duration-300"
                  ><div className='flex items-center justify-center gap-3'>
                      <FaUpload /> 
                  업로드하기
                  </div>
                
                </button>
              </form>
            </div>
          </div>
        </article>
    </section>
  );
};

export default FileUploadForm;
